import hero from "./assets/hero.jpg"
import thumbnailHero from "./assets/thumbnailHero.jpg"


export const WizzData = {
    title: "Leading the Design of a Mobile platform for English Learning",
    heroImage: hero,
    thumbnailImage:hero
}